import { Slide } from "@jelly/lesson";

import { task as task01 } from "../../../../../task/course-01/lesson-04/task-01";
import config from "appConfig";

const task: Slide = {
  title: "Determine the frequency and the wavelength. Deduce the velocity.",
  description: "Fill in the value.",
  layout: {
    type: "table",
    options: {
      cols: 1,
      rows: 2,
      rowsSize: [2, 1],
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "video",
                options: {
                  src: `${config.ASSETS_URL}/01/04/task/task-1.m4v`,
                  styles: {
                    paddingTop: "12.8%",
                  },
                },
              },
            },
          },
        ],
        [
          {
            variant: "__task__",
            data: {
              id: task01.id,
            },
          },
        ],
      ],
    },
  },
};

export default task;
